<template>
    <a class="o-Poster" :href="item.roam_products_url">
        <!-- Image -->
        <img
            v-if="srcset"
            :data-srcset="srcset"
            :alt="item.title"
            class="o-Poster__Image o-Image lazyload"
            width="367"
            height="250"
        >
        <img
            v-else
            :src="fallbackImage"
            :alt="item.title"
            class="o-Poster__Image o-Image"
        >

        <div class="o-Poster__content">
            <h6
                v-if="item['roam_products_categories.lvl0']"
                class="o-Poster__meta h6"
            >
                {{ item['roam_products_categories.lvl0'][0] }}
            </h6>
            <h4 class="o-Poster__title h4">{{ item.title }} </h4>
            <div
                v-if="dates(item.roam_products_eventDates)"
                class="text-xs mt-3"
            >
                {{ dates(item.roam_products_eventDates) }}
            </div>
            <p class="o-Poster__summary leading-tight small">{{ truncatedDescription }}</p>
        </div>
    </a>
</template>

<script>
import moment from 'moment';
import { truncate } from 'lodash';

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            fallbackImage: window.fallbackImage,
        };
    },

    computed: {
        srcset() {
            const images = this.item.roam_products_images || this.item.roam_common_pageHeader_image;
            return images && images.join(', ');
        },

        truncatedDescription() {
            if (this.item.roam_products_description) {
                return truncate(
                    this.item.roam_products_description.replace(/(<([^>]+)>)/ig, ''),
                    { length: 100, separator: /,? +/ },
                );
            }
            return '';
        },
    },

    methods: {
        dates(dates) {
            if (!dates) return null;
            const now = moment();
            let from = moment.unix(dates[0]);
            if (this.item.roam_products_next_event) {
                from = moment.unix(this.item.roam_products_next_event);
            }
            const to = moment.unix(dates[dates.length - 1]);

            let fromFormatted = from.format('D MMM YYYY');
            if (now > from) fromFormatted = now.format('D MMM YYYY');

            return from.isSame(to, 'day')
                ? fromFormatted
                : `${fromFormatted} - ${to.format('D MMM YYYY')}`;
        },
    },
};
</script>

<style lang="scss" scoped></style>
